import * as React from 'react'
import { StructuredText, renderNodeRule } from 'react-datocms'

import { Text } from '@factorialco/deprecated-design-system'
import {
  isBlockquote,
  isHeading,
  isList,
  isListItem,
  isParagraph,
} from 'datocms-structured-text-utils'

import * as styles from './index.vanilla.css'

type StructuredTextType = {
  id: string | number
  stepByStepDescription: string
}

const StepByStepDescription = ({ stepByStepDescription, id }: StructuredTextType) => {
  const parsedStepByStepDescription = JSON.parse(stepByStepDescription)

  return (
    <div className={styles.formattedText}>
      <StructuredText
        data={parsedStepByStepDescription}
        key={id}
        customNodeRules={[
          renderNodeRule(isHeading, ({ key, children }) => {
            return (
              <div className={styles.heading} role="heading" key={key}>
                <Text size="400" weight="medium" color="grey1000">
                  {children}
                </Text>
              </div>
            )
          }),
          renderNodeRule(isBlockquote, ({ key, children }) => {
            return (
              <p className={styles.blockquote} key={key}>
                {children}
              </p>
            )
          }),
          renderNodeRule(isList, ({ key, children }) => {
            return (
              <ol className={styles.list} key={key}>
                {children}
              </ol>
            )
          }),
          renderNodeRule(isListItem, ({ key, children }) => {
            return (
              <li className={styles.listItem} key={key}>
                {children}
              </li>
            )
          }),
          renderNodeRule(isParagraph, ({ key, children }) => {
            return (
              <p className={styles.paragraph} key={key}>
                {children}
              </p>
            )
          }),
        ]}
      />
    </div>
  )
}

export default StepByStepDescription
